/* This function populates the notes under each Scent
  Can't do this using liquid becauase we can onlly access metaobjects by
  handle a certain amount of times per page load.

  We were considering loading subcategories like Floral to the page using js as well
  so we could just assign a scent to a product when creating them and then handle 
  everything else dynamically, but it'd be really complicted to implement. Starting
  points are still commented out here.

*/
if (!customElements.get('main-collection-populate-notes')) {
  
  class MainCollectionPopulateNotes extends HTMLElement {
    constructor() {
      super();

      // Variables required to fill the filters interface on load
      this.allScents = this.querySelectorAll(".main-collection__filter__item__details");
      this.scentsJson = this.querySelector("#scent-metaobjects");
    // this.subcategories = []; //Prep work for dynamic subcategory injection

      this.init();
    }

    init() {
      if (!this.scentsJson) return;

      // Parse JSON
      this.scentsJson = JSON.parse(this.scentsJson.textContent);

    // const subcategoryCounts = {}; //Prep work for dynamic subcategory injection

      this.allScents.forEach(scentEl => {
        const scentJson = this.scentsJson.find(item => item.handle === scentEl.dataset.scent);
        if (!scentJson) return;

        // 🔹 Fill missing notes
        if (scentEl.classList.contains("main-collection__filter__item__details--fill-with-js")) {
          scentEl.querySelector('span')?.replaceChildren(scentJson.notes);
        }

        /* //Prep work for dynamic subcategory injection
        if (scentJson.subcategory) {
          scentJson.subcategory
            .split(',')
            .map(s => s.trim())
            .filter(s => s.length)
            .forEach(sub => {
              subcategoryCounts[sub] = (subcategoryCounts[sub] || 0) + 1;
            });
        } */
      });

      /* //Prep work for dynamic subcategory injection
      // Convert to array of objects and store
      this.subcategories = Object.entries(subcategoryCounts).map(([subcategory, count]) => ({
        subcategory,
        count
      }));
      console.log(this.subcategories);
      */
    }
  }

  customElements.define('main-collection-populate-notes', MainCollectionPopulateNotes);
}